import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export default function AvailableInventory({
  isAvailable,
  maxQuantity,
}: {
  isAvailable: boolean;
  maxQuantity: number;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="subtitle2" color="text.secondary" width="fit-content">
        {isAvailable
          ? `(Inventory: ${maxQuantity ? Intl.NumberFormat('en-US').format(maxQuantity) : 'Available'})`
          : '(Inventory: Not Available)'}
      </Typography>
      {isAvailable && !maxQuantity && (
        <Tooltip
          arrow
          title="Available means we have inventory enough to fulfill an order but we don’t have an exact number of items in inventory."
          enterTouchDelay={100}
        >
          <HelpOutlineIcon sx={{ color: 'text.secondary', width: 20, height: 20 }} />
        </Tooltip>
      )}
    </Stack>
  );
}
